import { Component, OnInit } from '@angular/core'
// TODO:Spartacus - // TODO:Spartacus - Class ModalService has been removed and is no longer part of the public API. Use 'LaunchDialogService' instead. For more information, see the 5.0 migration guide.
import { ICON_TYPE, LaunchDialogService } from '@spartacus/storefront'
import { DispenserType } from '../../../../../models/enum/dispenser.enum'
import { AppConfigurationService } from '../../../../../services/app-configuration.service'

@Component({
    selector: 'app-new-dispenser-agreement-modal',
    templateUrl: './new-dispenser-agreement-modal.component.html',
    styleUrls: ['./new-dispenser-agreement-modal.component.scss'],
    standalone: false
})
export class NewDispenserAgreementModalComponent implements OnInit {
  public dispenserType: string
  public typeDetails: string
  public iconTypes = ICON_TYPE
  public dispenserTypeEnum = DispenserType

  constructor(protected modalService: LaunchDialogService) {}

  identifi: string = `${AppConfigurationService.settings.dispenser.identifi}`
  easyCube: string = `${AppConfigurationService.settings.dispenser.easyCube}`
  smartCare: string = `${AppConfigurationService.settings.dispenser.smartCare}`

  ngOnInit(): void {
    if (this.dispenserType == 'IDENTIFI') {
      this.typeDetails = this.identifi
    } else if (this.dispenserType == 'EASY_CUBE') {
      this.typeDetails = this.easyCube
    } else if (this.dispenserType == 'SMART_CARE') {
      this.typeDetails = this.smartCare
    }
  }

  dismissModal(): void {
    // this.modalService.dismissActiveModal();
    this.modalService.closeDialog('null')
  }
}
